export default [
    {
        path: '/airline/allotment',
        props: true,
        component: () => import('@/views/Airline/Allotment'),
    },
    {
        path: '/airline/allotment/:allotmentId',
        props: true,
        component: () => import('@/views/Airline/Allotment/Stats'),
    },
    {
        path: '/airline/allotment/:allotmentId/flight',
        props: true,
        component: () => import('@/views/Airline/Allotment/Flight'),
    },
];
